var EraType;
(function (EraType) {
    EraType["stoneAge"] = "stoneAge";
    EraType["bronzeAge"] = "bronzeAge";
    EraType["minoanEra"] = "minoanEra";
    EraType["classicGreece"] = "classicGreece";
    EraType["earlyRome"] = "earlyRome";
    EraType["romanEmpire"] = "romanEmpire";
    EraType["byzantineEra"] = "byzantineEra";
    EraType["ageOfTheFranks"] = "ageOfTheFranks";
    EraType["feudalAge"] = "feudalAge";
    EraType["iberianEra"] = "iberianEra";
    EraType["kingdomOfSicily"] = "kingdomOfSicily";
    EraType["highMiddleAges"] = "highMiddleAges";
    EraType["earlyGothicEra"] = "earlyGothicEra";
    EraType["lateGothicEra"] = "lateGothicEra";
})(EraType || (EraType = {}));
export default EraType;
